/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { createConfig  } from './config';
import { baseTTS } from '../httpService/API';
export * from './common';

export const AIGC_PROXY_HOST = baseTTS;

// 导出创建配置的函数而不是固定的配置类
export const ConfigFactory = createConfig;

// 创建默认配置实例
export const Config = createConfig('','');
export default new Config();
